"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sync = exports.scanAccounts = exports.getAccountShape = void 0;
const bignumber_js_1 = require("bignumber.js");
const jsHelpers_1 = require("../../bridge/jsHelpers");
const account_1 = require("../../account");
const Cosmos_1 = require("./api/Cosmos");
const operation_1 = require("../../operation");
const helpers_1 = require("./helpers");
const logic_1 = require("./logic");
const getBlankOperation = (tx, fees, id) => ({
    id: "",
    hash: tx.txhash,
    type: "",
    value: new bignumber_js_1.BigNumber(0),
    fee: fees,
    blockHash: null,
    blockHeight: tx.height,
    senders: [],
    recipients: [],
    accountId: id,
    date: new Date(tx.timestamp),
    extra: {
        validators: [],
    },
    transactionSequenceNumber: parseInt(tx.tx.auth_info.signer_infos[0].sequence),
});
const txToOps = (info, accountId, txs) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const { address, currency } = info;
    const unitCode = currency.units[1].code;
    const ops = [];
    for (const tx of txs) {
        let fees = new bignumber_js_1.BigNumber(0);
        tx.tx.auth_info.fee.amount.forEach(elem => {
            if (elem.denom === unitCode)
                fees = fees.plus(elem.amount);
        });
        const op = getBlankOperation(tx, fees, accountId);
        const messages = tx.logs.map(log => log.events).flat(1);
        const mainMessage = (0, helpers_1.getMainMessage)(messages);
        if (mainMessage === undefined) {
            // happens when we don't know this message type in our implementation, example : proposal_vote
            continue;
        }
        const correspondingMessages = messages.filter(m => m.type === mainMessage.type);
        switch (mainMessage.type) {
            case "transfer":
                // TODO: handle IBC transfers here
                for (const message of correspondingMessages) {
                    const amount = (_a = message.attributes.find(attr => attr.key === "amount")) === null || _a === void 0 ? void 0 : _a.value;
                    const sender = (_b = message.attributes.find(attr => attr.key === "sender")) === null || _b === void 0 ? void 0 : _b.value;
                    const recipient = (_c = message.attributes.find(attr => attr.key === "recipient")) === null || _c === void 0 ? void 0 : _c.value;
                    if (amount && sender && recipient && amount.endsWith(unitCode)) {
                        if (op.senders.indexOf(sender) === -1)
                            op.senders.push(sender);
                        if (op.recipients.indexOf(recipient) === -1)
                            op.recipients.push(recipient);
                        op.value = op.value.plus((0, logic_1.parseAmountStringToNumber)(amount, unitCode));
                        if (sender === address) {
                            op.type = "OUT";
                        }
                        else if (recipient === address) {
                            op.type = "IN";
                        }
                    }
                }
                if (op.type === "OUT") {
                    op.value = op.value.plus(fees);
                }
                break;
            case "withdraw_rewards": {
                op.type = "REWARD";
                const rewardShards = [];
                let txRewardValue = new bignumber_js_1.BigNumber(0);
                for (const message of correspondingMessages) {
                    const validator = (_d = message.attributes.find(attr => attr.key === "validator")) === null || _d === void 0 ? void 0 : _d.value;
                    const amount = (_e = message.attributes.find(attr => attr.key === "amount")) === null || _e === void 0 ? void 0 : _e.value;
                    if (validator && amount && amount.endsWith(unitCode)) {
                        const amountString = (0, logic_1.parseAmountStringToNumber)(amount, unitCode);
                        rewardShards.push({
                            amount: new bignumber_js_1.BigNumber(amountString),
                            address: validator,
                        });
                        txRewardValue = txRewardValue.plus(amountString);
                    }
                }
                op.value = txRewardValue;
                op.extra.validators = rewardShards;
                break;
            }
            case "delegate": {
                op.type = "DELEGATE";
                op.value = new bignumber_js_1.BigNumber(fees);
                const delegateShards = [];
                for (const message of correspondingMessages) {
                    const amount = (_f = message.attributes.find(attr => attr.key === "amount")) === null || _f === void 0 ? void 0 : _f.value;
                    const validator = (_g = message.attributes.find(attr => attr.key === "validator")) === null || _g === void 0 ? void 0 : _g.value;
                    if (amount && validator && amount.endsWith(unitCode)) {
                        delegateShards.push({
                            amount: new bignumber_js_1.BigNumber((0, logic_1.parseAmountStringToNumber)(amount, unitCode)),
                            address: validator,
                        });
                    }
                }
                op.extra.validators = delegateShards;
                break;
            }
            case "redelegate": {
                op.type = "REDELEGATE";
                op.value = new bignumber_js_1.BigNumber(fees);
                const redelegateShards = [];
                for (const message of correspondingMessages) {
                    const amount = (_h = message.attributes.find(attr => attr.key === "amount")) === null || _h === void 0 ? void 0 : _h.value;
                    const validatorDst = (_j = message.attributes.find(attr => attr.key === "destination_validator")) === null || _j === void 0 ? void 0 : _j.value;
                    const validatorSrc = (_k = message.attributes.find(attr => attr.key === "source_validator")) === null || _k === void 0 ? void 0 : _k.value;
                    if (amount && validatorDst && validatorSrc && amount.endsWith(unitCode)) {
                        op.extra.sourceValidator = validatorSrc;
                        redelegateShards.push({
                            amount: new bignumber_js_1.BigNumber((0, logic_1.parseAmountStringToNumber)(amount, unitCode)),
                            address: validatorDst,
                        });
                    }
                }
                op.extra.validators = redelegateShards;
                break;
            }
            case "unbond": {
                op.type = "UNDELEGATE";
                op.value = new bignumber_js_1.BigNumber(fees);
                const unbondShards = [];
                for (const message of correspondingMessages) {
                    const amount = (_l = message.attributes.find(attr => attr.key === "amount")) === null || _l === void 0 ? void 0 : _l.value;
                    const validator = (_m = message.attributes.find(attr => attr.key === "validator")) === null || _m === void 0 ? void 0 : _m.value;
                    if (amount && validator && amount.endsWith(unitCode)) {
                        unbondShards.push({
                            amount: new bignumber_js_1.BigNumber((0, logic_1.parseAmountStringToNumber)(amount, unitCode)),
                            address: validator,
                        });
                    }
                }
                op.extra.validators = unbondShards;
                break;
            }
        }
        if (tx.tx.body.memo != null) {
            op.extra.memo = tx.tx.body.memo;
        }
        op.id = (0, operation_1.encodeOperationId)(accountId, tx.txhash, op.type);
        if (op.type) {
            ops.push(op);
        }
    }
    return ops;
};
const getAccountShape = (info) => __awaiter(void 0, void 0, void 0, function* () {
    const { address, currency, derivationMode, initialAccount } = info;
    const accountId = (0, account_1.encodeAccountId)({
        type: "js",
        version: "2",
        currencyId: currency.id,
        xpubOrAddress: address,
        derivationMode,
    });
    const { balances, blockHeight, txs, delegations, redelegations, unbondings, withdrawAddress } = yield new Cosmos_1.CosmosAPI(currency.id).getAccountInfo(address, currency);
    const oldOperations = (initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.operations) || [];
    const newOperations = txToOps(info, accountId, txs);
    const operations = (0, jsHelpers_1.mergeOps)(oldOperations, newOperations);
    let balance = balances;
    let delegatedBalance = new bignumber_js_1.BigNumber(0);
    let pendingRewardsBalance = new bignumber_js_1.BigNumber(0);
    let unbondingBalance = new bignumber_js_1.BigNumber(0);
    for (const delegation of delegations) {
        delegatedBalance = delegatedBalance.plus(delegation.amount);
        balance = balance.plus(delegation.amount);
        pendingRewardsBalance = pendingRewardsBalance.plus(delegation.pendingRewards);
    }
    for (const unbonding of unbondings) {
        unbondingBalance = unbondingBalance.plus(unbonding.amount);
        balance = balance.plus(unbonding.amount);
    }
    let spendableBalance = balance.minus(unbondingBalance.plus(delegatedBalance));
    if (spendableBalance.lt(0)) {
        spendableBalance = new bignumber_js_1.BigNumber(0);
    }
    const shape = {
        id: accountId,
        xpub: address,
        balance: balance,
        spendableBalance,
        operationsCount: operations.length,
        blockHeight,
        cosmosResources: {
            delegations,
            redelegations,
            unbondings,
            delegatedBalance,
            pendingRewardsBalance,
            unbondingBalance,
            withdrawAddress,
        },
    };
    if (shape.spendableBalance && shape.spendableBalance.lt(0)) {
        shape.spendableBalance = new bignumber_js_1.BigNumber(0);
    }
    return Object.assign(Object.assign({}, shape), { operations });
});
exports.getAccountShape = getAccountShape;
exports.scanAccounts = (0, jsHelpers_1.makeScanAccounts)({ getAccountShape: exports.getAccountShape });
exports.sync = (0, jsHelpers_1.makeSync)({ getAccountShape: exports.getAccountShape });
//# sourceMappingURL=js-synchronisation.js.map